import { Card, Typography } from "../material-old";
import { Button, Form, FormProps, Input, message, Select, Space } from "antd";
import {
  BaseRequirementOption,
  baseRequirementTypeOptions,
} from "./fixtures/baseRequirementTypeOptions.ts";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { createBaseRequirement } from "../../redux/actions/baseRequirementsActions.tsx";
import { BreadcrumbComponent } from "./BreadcrumbComponent.tsx";
import { SaveFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

interface FormValues {
  name: string;
  type: BaseRequirementOption;
}

export const Create: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.baseRequirements);

  const handleResetForm = () => form.resetFields();

  const handleSubmitForm: FormProps<FormValues>["onFinish"] = async (
    values,
  ) => {
    try {
      await dispatch(
        createBaseRequirement({
          name: values.name,
          type: values.type,
        }),
      ).unwrap();

      messageApi.open({
        type: "success",
        content: "Requisito creado.",
      });
      handleResetForm();

      setTimeout(() => {
        navigate("/requirements");
      }, 1500);
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo crear el requisito."));
    }
  };

  return (
    <Card className="mx-auto py-8 px-20 md:w-8/12">
      {contextHolder}
      <div className="flex justify-end">
        <BreadcrumbComponent pathText="Crear requisito" />
      </div>
      <div className="text-center mt-4">
        <Space>
          <Typography variant="h5" color="blue-gray">
            Crear Requisito
          </Typography>
        </Space>
      </div>
      <hr className="mt-4" />
      <div className="text-sm mt-8 flex flex-col w-full">
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={handleSubmitForm}
        >
          <Form.Item<FormValues>
            name="name"
            label="Nombre"
            rules={[{ required: true }]}
          >
            <Input placeholder="Tenant - Photo ID" />
          </Form.Item>
          <Form.Item<FormValues>
            name="type"
            label="Tipo"
            rules={[{ required: true }]}
          >
            <Select placeholder="Selecciona un tipo" allowClear>
              {baseRequirementTypeOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SaveFilled />}
              >
                Crear
              </Button>
              <Button htmlType="button" onClick={handleResetForm}>
                Restablecer
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Card>
  );
};
